export const getDataByFetch = async (url) => {
    const dt = new Date().getTime();
    try {
        const response = await fetch(`${url}?dt=${dt}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
}

const optaStyles = `
    div.puntualizarjugadores {
        display: flex;
        flex-direction: column;   
        justify-content: center;                   
    
        width:100%; 
        margin-bottom:45px;       
    }
      
    .qualifyplayer_content {
        display: flex;
        flex-direction: column;  
        margin-top: 20px;        
        margin-bottom: 29px;
    }

    .qualifyplayer_header {
        display: flex;
        flex-direction: row; 
        align-items:center;
        height: 71px;
        background-color: #fbf6f6;
        color: black;
    }

    .qualifyplayer_body {
        display: flex;
        flex-direction: row; 
        justify-content: space-around;
        padding: 7px;
        padding-top: 19px;
        background-color: white;
        flex-wrap: wrap;
    }

    .buttonCont button {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        background-color: white;
        color: #a2a2a2;
        border: 3px solid #a2a2a2;
        padding: 0px;
        font-weight:800;
    }

    .buttonCont button {
        transition: all 300ms;
    }

    .qualifyplayer_on {
        border: none !important;
        transform: scale(1.2) !important;
        color: white !important;
        background-color: #00cfb7 !important;
        font-weight: bold;
    }

    .playerPortraitCont {
        flex-basis: 71px;
        height: 71px;
    }

    .playerDataCont {
        flex-grow: 13;
        font-size: 18px;
        padding-left: 10px;
    }

    .playerName {
        font-weight: bold;
        font-size: 22px;
        padding-bottom: 0px;
        font-family: var(--secondary-font-bold);
        font-weight: 800;
    }

    .playerPos {
        text-transform: uppercase;
        font-size: 15px;
        color: #646464;
        padding-top: 3px;
        font-family: var(--secondary-font-regular);
    }

    .playerProm {
        font-weight: bold;
        color: #00cfb7;
    }

    .promCont {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .headerPromText {
        padding-right: 10px;
    }

    .headerPromNumb {
        color: #707070;
        font-weight: bold;
    }

    .qualifyplayer_header_promedio {
        flex-grow: 1;
        font-size: 18px;
        text-align: center;
        display: flex;
        flex-direction: column;
        font-family: var(--secondary-font-bold);
        font-weight: 800;
        align-content: center;
        justify-content: center;
        height: 71px;
        border-left: 1px solid black;
    }

    #qualifyplayer_submit {
        display: block; 
        margin: 0 auto;
        margin-top: 20px;
        padding: 7px 17px;
        border: none;
        border-radius: 5px;
        background-color: #00cfb7;
        color:  white;
        font-weight: bold;
        cursor: pointer;
        transition: all 2s ease;
        font-size: 12px;
    }

    #qualifyplayer_submit:hover {
        background-color: #009f8d;
    }

    .qualifyplayer_alert {
        border: 1px solid red;
        box-shadow: 0px 0px 5px red !important;
    }

    #datawarning,
    #datawarningCount {
        margin-top: 20px;
        font-size: 16px;
        text-align: center;
        font-family: var(--secondary-font-bold);
        font-weight: 800;
    }

    .qualifyplayer_login {
        color:  #707070;
        margin-top: 20px;
        font-size: 15px;    
        display: block;
        margin: 0 auto;
        margin-top: 20px;
        padding:5px;
        text-align: center;
        font-family: var(--secondary-font-bold);
        font-weight: 800;
    }
    
    .qualifyplayer_login a {
        border-bottom: 3px solid #00cfb7;
        padding-bottom: 4px;
    }

    #submit_spinner {
        display: inline-block; 
        width:15px; 
        height:15px; 
        vertical-align: top;
        border-top: 3px solid #fafafa;
        border-left: 2px solid #fafafad6;
        border-bottom: 1px solid #fafafaba;
        border-right: 2px solid transparent;
        border-radius:50px; 
        margin: 0 auto; 
        margin-left: 15px;
        margin-right: 5px; 
        animation: spinner_submit .6s infinite linear;
    }

    .divHidden {
        display: none;
    }

    @keyframes spinner_submit { 
        to {
            transform: rotate(359deg);
        }
    }
                
    @media (max-width:719px){
        .qualifyplayer_body {
            margin: 0 auto;
        }
    
        .qualifyplayer_content {
            margin-bottom: 1px;
        }
    
        .buttonCont {
            width: 20%;
            margin-bottom: 10px;
            justify-content: center;
            display: flex;
        }
    
        .buttonCont button {
            border: 2px solid #a2a2a2;
        }
    
        .promCont {
            flex-direction: column;
        }
    
        .headerPromText {
            padding: 5px;
        }
    
        .twoDots {
            display: none;
        }
    }
`;

export const loadStyles = () => {
    let style = document.head.querySelector('#qualify_cup');
    if (!style) {
        const newNodo = document.createElement('style');
        newNodo.id = 'qualify_cup';
        document.head.appendChild(newNodo);
        style = document.head.querySelector('#qualify_cup');
    }
    //style.innerHTML = `${style.innerHTML}${optaStyles}`;
    style.innerHTML = `${optaStyles}`;
}

export const enableSyleHover = () => {
    const nodoStyle = document.head.querySelector('#qualify_cup');
    if (nodoStyle) {
        nodoStyle.innerHTML = `
            ${nodoStyle.innerHTML}
            .buttonCont button:hover {
                border: 2px solid #00cfb7;
                color: #00cfb7;
                transform: scale(1.2);
            }
            .qualifyplayer_off {
                cursor: pointer;
            }
        `;
    }
}

export const removeEffectHover = () => {

    const styleTag = document.head.querySelector('#qualify_cup');
    const sheet = styleTag.sheet ? styleTag.sheet : styleTag.styleSheet;

    if (sheet.cssRules) { // all browsers, except IE before version 9
        for (let i=0; i<sheet.cssRules.length; i++) {
            if (sheet.cssRules[i].selectorText === '.buttonCont button:hover') {        
               sheet.deleteRule (i);
            }
            if (sheet.cssRules[i].selectorText === '.qualifyplayer_off') {        
                sheet.deleteRule (i);
            }
        }  
    }
}

export const setContentPlayers = (response_players = [], players = [], button = "on") => {
    let arrayQualifyPlayers = [];
    let data_players = response_players.map(player => {
        if (!!arrayQualifyPlayers.find(p => p.id === player.id)) return '';
        const dataPlayer = {
            id: player.id,
            status: false,
            qualify: 0,
        }
        arrayQualifyPlayers.push(dataPlayer);
        const dp = (players && players.length) ? players.find(dp => dp.id === player.id) : false;
        return `
                <div class="qualifyplayer_content" data-playerid="${player.id}">
                    <div class="qualifyplayer_header">
                        <div class="playerPortraitCont">
                            <img class="playerPortrait" src="${player.imgUrl}" alt="${player.name}" loading="lazy" width="354" height="354">
                        </div>
                        <div class="playerDataCont">
                            <div class="playerName">${player.name}</div>
                            <div class="playerPos">${!!dp && dp?.position ? dp.position : ''}</div>
                        </div>
                        <div class="qualifyplayer_header_promedio divHidden">-</div>
                    </div>
                    ${(button === 'on')
                ? `
                        <div class="qualifyplayer_body">
                            <div class="buttonCont">
                                <button class="qualifyplayer_off" data-index="1" data-id="${player.id}">1</button>
                            </div>
                            <div class="buttonCont">
                                <button class="qualifyplayer_off" data-index="2" data-id="${player.id}">2</button>
                            </div>
                            <div class="buttonCont">
                                <button class="qualifyplayer_off" data-index="3" data-id="${player.id}">3</button>
                            </div>
                            <div class="buttonCont">
                                <button class="qualifyplayer_off" data-index="4" data-id="${player.id}">4</button>
                            </div>
                            <div class="buttonCont">
                                <button class="qualifyplayer_off" data-index="5" data-id="${player.id}">5</button>
                            </div>
                            <div class="buttonCont">
                                <button class="qualifyplayer_off" data-index="6" data-id="${player.id}">6</button>
                            </div>
                            <div class="buttonCont">
                                <button class="qualifyplayer_off" data-index="7" data-id="${player.id}">7</button>
                            </div>
                            <div class="buttonCont">
                                <button class="qualifyplayer_off" data-index="8" data-id="${player.id}">8</button>
                            </div>
                            <div class="buttonCont">
                                <button class="qualifyplayer_off" data-index="9" data-id="${player.id}">9</button>
                            </div>
                            <div class="buttonCont">
                                <button class="qualifyplayer_off" data-index="10" data-id="${player.id}">10</button>
                            </div>
                        </div>
                        `
                : ''}
                </div>
                `;
    }).join("");
    return {
        arrayQualifyPlayers,
        data_players
    }
}

export const setPromedios = (players = [], average = [], count = 'off', minCount = 0) => {
    let maxCount = 0;
    players.forEach((player) => {
        const nodoAverage = document.querySelector(`div[data-playerid="${player.id}"] .qualifyplayer_header_promedio`);
        const playerAverage = average.find(p => p.id === player.id);
        if (!playerAverage) console.warn(`Player ${player.id} not found in average data.`);
        if (nodoAverage && playerAverage) {
            nodoAverage.classList.remove('divHidden');
            nodoAverage.innerHTML = `
                <div class="promCont">
                    <div class="headerPromText">Promedio<span class="twoDots">: </span></div>
                    <div class="headerPromNumb">${playerAverage.qualify}</div>
                </div>                        
            `;
            if (count === 'on' && playerAverage.count >= minCount && playerAverage.count > maxCount) {
                maxCount = playerAverage.count;
                if (!document.getElementById('datawarningCount')) {
                    const nodoParent = document.getElementById('datawarning').parentNode;
                    const nodoDivCount = document.createElement('div');
                    nodoDivCount.id = 'datawarningCount';
                    nodoParent.insertBefore(nodoDivCount, document.getElementById('datawarning'));
                }
                document.getElementById('datawarningCount').innerHTML = `Votantes: ${maxCount}`;
            }
        }
    });
}

export const qualifyOld = (nodoQualifyPlayer, players = [], qualify, listener, average) => {

    const datawarning = document.getElementById('datawarning');
    datawarning.innerHTML = `Ya puntuaste este partido.`;

    Array.from(nodoQualifyPlayer.querySelectorAll('.qualifyplayer_body'))
        .forEach(element => {
            element.removeEventListener("click", listener);
        });

    players.forEach(data => {
        const nodo = document.querySelector(`div [data-playerid="${data.id}"]`);
        if (nodo) {
            const playerQualify = qualify.data.players.find(p => p.id === data.id);
            if (!playerQualify) console.warn(`Player ${data.id} not found in qualify data.`);
            Array.from(nodo.querySelectorAll(`button`))
                .forEach((element, index) => {
                    element.className = "qualifyplayer_off";
                    if (!!playerQualify && ((index + 1) == playerQualify.qualify)) {
                        element.className = "qualifyplayer_on";
                    }
                });
        }
    });

}

export const listener = async (e) => {

    e.stopPropagation();

    if (e.target.nodeName == "BUTTON") {

        const datawarning = document.getElementById('datawarning');

        const qualify = e.target.dataset.index;
        const playerId = e.target.dataset.id;
        const nodo = document.querySelector(`div [data-playerid="${playerId}"]`);

        const nodoQualifyOld = nodo.querySelector('.qualifyplayer_on');
        if (nodoQualifyOld) {
            nodoQualifyOld.classList.replace("qualifyplayer_on", "qualifyplayer_off");
        }
        e.target.classList.replace("qualifyplayer_off", "qualifyplayer_on");

        const notaId = e.currentTarget.notaId;
        const userId = e.currentTarget.userId;
        const url = e.currentTarget.url;
        const average = e.currentTarget.average;
        const arrayQualifyPlayers = e.currentTarget.arrayQualifyPlayers;

        arrayQualifyPlayers?.forEach((e, i) => {
            if (e.id == playerId) {
                arrayQualifyPlayers[i].status = true;
                arrayQualifyPlayers[i].qualify = qualify;
                if (nodo.classList.contains('qualifyplayer_alert')) {
                    nodo.classList.remove('qualifyplayer_alert');
                }
            }
        });

        let submitStatus = true;
        arrayQualifyPlayers.forEach((e) => {
            if (e.status === false) submitStatus = false;
        });

        if (submitStatus) {

            datawarning.style.display = "none";
            datawarning.innerHTML = "";

            const dataObject = {
                userId,
                data: {
                    players: arrayQualifyPlayers,
                    notaId,
                }                                            
            }

            //boton submit
            const buttonSubmit = document.getElementById('qualifyplayer_submit');
            if (buttonSubmit) {
                buttonSubmit.addEventListener("click", submitListener, false);
                buttonSubmit.paramListener = listener;
                buttonSubmit.paramUrl = url;
                buttonSubmit.paramDataObject = dataObject;
                buttonSubmit.paramPromedios = average;
                buttonSubmit.paramEnable = true;
            }

        }

    }
}

export const submitListener = async (e) => {

    const paramEnable = e.currentTarget.paramEnable;
    const paramArrayQualifyPlayers = e.currentTarget.paramArrayQualifyPlayers;
    const nodoOpta = e.currentTarget.paramNodoOpta;
    const paramListener = e.currentTarget.paramListener;
    const average = e.currentTarget.paramPromedios;
    const dataSet = e.currentTarget.paramDataObject;
    const url = e.currentTarget.paramUrl;
    const matchPlayers = e.currentTarget.paramMatchPlayers;
    const datawarning = document.getElementById('datawarning');

    if (paramEnable === false) {
        
       paramArrayQualifyPlayers.forEach(p => {
            const nodo = document.querySelector(`div [data-playerid="${p.id}"]`);
            if (p.status === false) {
                nodo.classList.add('qualifyplayer_alert');
            } else {
                nodo.classList.remove('qualifyplayer_alert');
            }
        });
        datawarning.style.display = "block";
        datawarning.innerHTML = "Quedan jugadores sin puntuar.";
        return;
    }

    e.target.disabled = true;
    e.target.innerHTML = `${e.target.innerHTML}<div id="submit_spinner"></div>`;
        
    Array.from(nodoOpta.current.querySelectorAll('.qualifyplayer_body'))
        .forEach(element => {
            element.removeEventListener("click", paramListener);
        });    

    dataSet.data.players =  dataSet.data.players.map( e => {
        return {
            id: e.id,
            status: e.status,
            qualify: Number(e.qualify),
        }
    });    

    removeEffectHover();

    console.log(dataSet);

    try {

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataSet),
        });

        if (response.status !== 200) throw new Error(`${response.status}`);

        const responseData = await response.json();
        console.log(responseData);

        e.target.innerHTML = `Puntuación cerrada`;        
        e.target.style.backgroundColor = '#008475';
        e.target.style.cursor = 'auto';        

        setPromedios(matchPlayers,average);

    } catch (err) {
        console.error(err);
        datawarning.style.display = "block";
        datawarning.innerHTML = "Error al enviar tu puntuación.";
    }

}